import { C as Component } from "./component-BFVg3Q7H.js";
import { d as defineCustomElement } from "./utilities-BToXpjgA.js";
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#formatContent();
  }
  /**
   * Formats all RTE content elements
   */
  #formatContent() {
    this.querySelectorAll("table").forEach(this.#formatTable.bind(this));
  }
  /**
   * Wraps a table in a scrollable container for mobile responsiveness
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("rte-table-wrapper");
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}
defineCustomElement("rte-formatter", RTEFormatter);
